import { Component } from '@theme/component';

class EscQuickAddModal extends Component {
  requiredRefs = ['modalContent'];

  #previousScrollY = 0;

  connectedCallback() {
    super.connectedCallback();
  }

  switchProduct(event) {
    const productId = event.target.dataset.productId;

    if (!productId) {
      return;
    }

    this.refs.modalContent.map((content) => {
      content.classList.toggle('esc-quick-add-modal__content--hidden', content.dataset.productId != productId);
    });
  }

  showModal() {
    const scrollY = window.scrollY;
    this.#previousScrollY = scrollY;

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;

      this.classList.remove('esc-quick-add-modal--hidden');
    });
  }

  hideModal() {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: this.#previousScrollY, behavior: 'instant' });

    this.classList.add('esc-quick-add-modal--hidden');
    this.refs.modalContent.map((content, index) => {
      content.classList.toggle('esc-quick-add-modal__content--hidden', index != 0);
    });

    this.remove();
  }
}

if (!customElements.get('esc-quick-add-modal')) {
  	customElements.define('esc-quick-add-modal', EscQuickAddModal);
}